import { useMemo } from 'react';
import useHelpNote from './useHelpNote';
import helpNoteTitleIfPresent from './helpNoteTitleIfPresent';
export default function useHelpNoteTitleIfPresent(title) {
    const getHelpNoteTooltipTitle = useHelpNote();
    return useMemo(() => helpNoteTitleIfPresent(getHelpNoteTooltipTitle, title), [
        getHelpNoteTooltipTitle,
        title,
    ]);
}
